import { render, staticRenderFns } from "./barcodesinreturnStorageHistory.vue?vue&type=template&id=6437c915&scoped=true&"
import script from "./barcodesinreturnStorageHistory.vue?vue&type=script&lang=js&"
export * from "./barcodesinreturnStorageHistory.vue?vue&type=script&lang=js&"
import style0 from "./barcodesinreturnStorageHistory.vue?vue&type=style&index=0&id=6437c915&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6437c915",
  null
  
)

export default component.exports